/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Directory_Submit_Check_ExistsInputs */

const en_directory_submit_check_exists = /** @type {(inputs: Directory_Submit_Check_ExistsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Already listed: ${i?.name}.`)
};

const zh_directory_submit_check_exists = /** @type {(inputs: Directory_Submit_Check_ExistsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已收录：${i?.name}。`)
};

/**
* | output |
* | --- |
* | "Already listed: {name}." |
*
* @param {Directory_Submit_Check_ExistsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_check_exists = /** @type {((inputs: Directory_Submit_Check_ExistsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Check_ExistsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_check_exists(inputs)
	return zh_directory_submit_check_exists(inputs)
});
export { directory_submit_check_exists as "directory.submit.check.exists" }